/**
 * 결함 타입 JSON에서 id·부모 id를 꺼낸다.
 * parentId 가 있으면(클라이언트 정규화 결과 등) 우선하고, 없으면 Spring Data REST(HAL) parent 를 해석한다.
 */

/**
 * @param {string} uri
 * @returns {number|null}
 */
export function extractDefectTypeIdFromHalUri(uri) {
  if (!uri || typeof uri !== 'string') return null;
  let m = uri.match(/\/defectTypes\/(\d+)(?:\/)?(?:\?.*)?$/);
  if (m) return Number(m[1]);
  m = uri.match(/(?:^|[/?#])defectTypes\/(\d+)(?:\/|$|[?#])/);
  if (m) return Number(m[1]);
  const m2 = uri.match(/defectTypes\((\d+)\)/);
  return m2 ? Number(m2[1]) : null;
}

/**
 * 한 건의 defectType 리소스에서 숫자 seq(id) 후보를 반환한다.
 * @param {object|null|undefined} t
 * @returns {number|null}
 */
export function resolveDefectTypeRowId(t) {
  if (t == null) return null;
  if (t.id != null && t.id !== '') {
    const n = Number(t.id);
    if (Number.isFinite(n)) return n;
  }
  if (t.seq != null && t.seq !== '') {
    const n = Number(t.seq);
    if (Number.isFinite(n)) return n;
  }
  const href = typeof t._links?.self?.href === 'string' ? t._links.self.href : '';
  const fromSelf = extractDefectTypeIdFromHalUri(href);
  return fromSelf != null ? fromSelf : null;
}

/**
 * 부모 seq. 루트는 null.
 * @param {object|null|undefined} type
 * @returns {number|null}
 */
export function resolveDefectTypeParentId(type) {
  if (!type) return null;
  if (Object.prototype.hasOwnProperty.call(type, 'parentId')) {
    if (type.parentId == null || type.parentId === '') return null;
    const n = Number(type.parentId);
    return Number.isFinite(n) ? n : null;
  }
  if (type.parent == null || type.parent === undefined) return null;
  const p = type.parent;

  if (typeof p === 'number') {
    return Number.isFinite(p) ? p : null;
  }
  if (typeof p === 'string') {
    if (p.trim() === '') return null;
    const direct = Number(p);
    if (Number.isFinite(direct)) return direct;
    return extractDefectTypeIdFromHalUri(p);
  }
  if (typeof p === 'object') {
    if (p.id != null && p.id !== '') {
      const n = Number(p.id);
      if (Number.isFinite(n)) return n;
    }
    if (p.seq != null && p.seq !== '') {
      const n = Number(p.seq);
      if (Number.isFinite(n)) return n;
    }
    if (typeof p.href === 'string') {
      return extractDefectTypeIdFromHalUri(p.href);
    }
  }
  return null;
}

/**
 * GeoServer module_defects_by_new_type 의 defect_codes(viewparams)용 숫자 id 목록.
 * @param {Array} items
 * @returns {number[]}
 */
export function extractDefectTypeIdsForWfs(items) {
  if (!Array.isArray(items)) return [];
  const out = [];
  for (const dt of items) {
    const id = resolveDefectTypeRowId(dt);
    if (id != null && Number.isFinite(Number(id))) {
      out.push(Number(id));
    }
  }
  return out;
}
